import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileSrc = (fileId) => {
  const token = localStorage.getItem("gh_token") || "";
  return `${API}/files/${fileId}/download?auth=${encodeURIComponent(token)}`;
};
